

export const GMAPIK = "AIzaSyAKA5fKBGDB84S8AqOYXfEcPsjjUF2WypU";